import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { leadCategories } from "@/mocks/leads";

export default function CategorySection() {
  return (
    <section className="px-4 md:px-6 py-14 md:py-20" aria-labelledby="category-title">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-5">
          <SectionHeading
            id="category-title"
            eyebrow="主题分类"
            title="你的线索属于哪一类"
            desc="选对类别，能让线索更快到达熟悉这个领域的编辑手上。拿不准也没关系，可以选最接近的一项。"
          />
          <Link
            to="/leads"
            className="inline-flex items-center gap-2 text-sm font-label text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap shrink-0"
          >
            查看全部线索
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {leadCategories.map((category) => (
            <Link
              key={category.slug}
              to={`/leads?category=${category.slug}`}
              className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5 hover:border-secondary-400 hover:bg-secondary-50 transition-colors cursor-pointer"
            >
              <span className="w-11 h-11 rounded-md bg-secondary-100 text-secondary-800 flex items-center justify-center shrink-0 group-hover:bg-secondary-500 group-hover:text-background-50 transition-colors">
                <i className={`${category.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <span className="flex-1">
                <span className="block font-heading text-base font-bold text-foreground-950">{category.name}</span>
                <span className="mt-1.5 block text-sm text-foreground-600 leading-relaxed">{category.desc}</span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}